import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { theme } from "styles";

import Text from "components/ui/Text";

import Danger from "assets/icons/danger-icon.svg";
import Success from "assets/icons/success-icon.svg";
import EyeOn from "assets/icons/eye_on.svg";
import EyeOff from "assets/icons/eye_off.svg";

const TextField = ({
  pattern = true,
  label,
  maxLength,
  type = "text",
  value,
  onChange,
  placeholder,
  autoFocus,
  disabled,
  focused,
  onFocus,
  onBlur,
  onKeyUp,
  validation,
  authCount,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const inputEl = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      inputEl.current.focus();
    }
  }, [autoFocus]);

  return (
    <Wrapper css={props.css}>
      <label>
        <Text color="gray80" fontSize="14px" lineHeight="18px">
          {label}
        </Text>
      </label>
      {pattern ? (
        <WrapperInput focused={focused}>
          <InputText
            ref={inputEl}
            type={type}
            pattern="\d*"
            maxLength={maxLength}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            autoFocus={autoFocus}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyUp={onKeyUp}
            color={props.color}
            disabled={disabled}
          />
          {label === "인증번호" && (
            <div className="WrapperAuth">
              <Text color="primary50" fontSize="12px" lineHeight="16px">
                {`${Math.floor(authCount / 60)
                  .toString()
                  .padStart(2, "0")}:${(authCount % 60)
                  .toString()
                  .padStart(2, "0")}`}
              </Text>
            </div>
          )}
        </WrapperInput>
      ) : (
        <WrapperInput focused={focused}>
          <InputText
            ref={inputEl}
            type={isVisible ? "text" : type}
            maxLength={maxLength}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            autoFocus={autoFocus}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyUp={onKeyUp}
            color={props.color}
            disabled={disabled}
          />
          {type === "passwordWithEye" && (
            <ViewIcon
              isVisible={isVisible}
              onClick={() => setIsVisible(!isVisible)}
            />
          )}
        </WrapperInput>
      )}
      {validation && (
        <WrapperValidation>
          {validation.color !== "gray20" && (
            <img
              src={validation.color === "danger" ? Danger : Success}
              alt="back"
            />
          )}
          <Text color={validation.color} fontSize="12px" lineHeight="16px">
            {validation.text}
          </Text>
        </WrapperValidation>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  label {
    display: inline-block;
    margin-bottom: 2px;
  }
  ${(props) => props.css}
`;

const WrapperInput = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid ${theme.colors["line30"]};
  border: ${(props) =>
    props.focused && `2px solid ${theme.colors["primary100"]}`};
  border-radius: 8px;
  .WrapperAuth {
    display: flex;
    align-items: center;
    margin-right: 16px;
  }
`;
const ViewIcon = styled.span`
  background-image: url(${(props) => (props.isVisible ? EyeOn : EyeOff)});
  background-repeat: no-repeat;
  background-position: center center;
  padding: 0 12px;
  display: inline-block;
  width: 48px;
`;
const InputText = styled.input`
  color: ${(props) => theme.colors[props.color]};
  display: inline-block;
  padding: 12px 16px;
  width: 100%;
  height: 48px;
  background-color: white;
  border-radius: 8px;
  line-height: 24px;
  border: none;
  :disabled {
    background: #fff;
    opacity: 1;
  }
  ${(props) => props.css}
`;

const WrapperValidation = styled.div`
  margin-top: 8px;
  display: flex;
  img {
    margin-right: 6px;
  }
`;

export default TextField;
